export const SkipInkClasses = {
  ".skip-ink-auto": {
    "text-decoration-skip-ink": "auto", // Default behavior, skips over descenders and inline elements
  },
  ".skip-ink-none": {
    "text-decoration-skip-ink": "none", // No skipping, underline will pass through all elements
  },
  ".skip-ink-all": {
    "text-decoration-skip-ink": "all", // Skips all descenders, inline elements, etc.
  },
} as const;
